module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar-block"
  }, [_c('CalendarHeader', {
    attrs: {
      "days": _vm.daysOfTheWeeks
    }
  }), _c('CalendarMonth', {
    attrs: {
      "items": _vm.items,
      "month": _vm.month,
      "year": _vm.year
    },
    on: {
      "openPopup": _vm.openPopup,
      "prevMonth": _vm.prev,
      "nextMonth": _vm.next
    }
  }, [_vm._t("blockPopup", null, {
    "slot": "popup"
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4edfc114","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/remote-edu/calendar/components/calendar/CalendarBlock.vue
// module id = 2d38d1aa5c094e58c427
// module chunks = 7